<template>
    <div class="flex flex-col items-center justify-center transition duration-500 ease-in-out dark:text-white items-center bg-gray-900 sm:rounded-3xl shadow-xl p-0 sm:mb-8">
        <carousel :items-to-show="1" :autoplay="6000" :wrap-around="true">
            <slide v-for="(image, index) in slides" :key="index">
                <a :href="route(image.route)"><img v-bind:src="asset(image.src)" :alt="image.alt"></a>
            </slide>
        </carousel>
    </div>
</template>

<script>

import 'vue3-carousel/dist/carousel.css';
import { reactive } from 'vue'
import { Carousel, Slide } from 'vue3-carousel'

export default {
    components: {
        Carousel,
        Slide,
    },

    setup(props) {
        const slides = reactive([
            {
                src: 'images/banners/enhanced-jackpots-ftp.jpg',
                route: 'dashboard',
                alt: 'Have You Created Your Mini League',
            },
        ])

        return {
            slides,
        }
    }
}

</script>
